import TestimonialCard from './TestimonialCard';
import type { TestimonialsProps } from './useTestimonials';

const TestimonialsMobile = ({ data }: TestimonialsProps) => {
  return (
    <section
      id="testimonials"
      className="flex flex-col items-center gap-10 bg-surface-card px-6 py-16"
    >
      <div className="flex flex-col items-center gap-4 text-center">
        <span className="font-body text-xs font-semibold tracking-widest text-accent-text">
          {data.label}
        </span>
        <h2 className="font-heading text-3xl font-medium text-foreground-primary">
          {data.title}
        </h2>
      </div>

      <div className="flex w-full flex-col gap-6">
        {data.testimonials.map((testimonial, index) => (
          <TestimonialCard key={index} testimonial={testimonial} />
        ))}
      </div>
    </section>
  );
};

export default TestimonialsMobile;
